import type { PayrollRatesOfType, PayrollSlot } from '../../types';
import { formatDateKey, formatVnd } from '../../utils/money';

const slotLabels: Record<PayrollSlot, string> = { TEACHER: 'Lương giảng dạy', ASSISTANT: 'Lương trợ giảng' };

// The per-shift rates that apply within the selected range, by shift type,
// e.g. "Ca 120 phút: 400.000 until 30/09 then 450.000 from 01/10".
export function RatesInRange({ rates, from }: { rates: Record<PayrollSlot, PayrollRatesOfType[]>; from: string }) {
    return (
        <dl className="grid gap-3 sm:grid-cols-2">
            {(['TEACHER', 'ASSISTANT'] as PayrollSlot[]).map(slot => (
                <div key={slot} className="min-w-0">
                    <dt className="text-sm font-medium text-ink-700">{slotLabels[slot]}</dt>
                    <dd className="mt-1 space-y-1 text-sm">
                        {rates[slot].length === 0 ? (
                            <p className="text-ink-500">Chưa có mức lương</p>
                        ) : rates[slot].map(type => (
                            <div key={type.shiftTypeId}>
                                <span className="text-ink-600">{type.name}: </span>
                                {type.entries.length === 0 ? (
                                    <span className="text-warning-700">chưa có mức lương</span>
                                ) : type.entries.map((entry, index) => (
                                    <span key={entry.effectiveFrom} className="tabular-nums">
                                        {index > 0 ? ', ' : ''}
                                        <span className="font-semibold text-ink-900">{formatVnd(entry.rate)}/ca</span>
                                        {entry.effectiveFrom > from ? <span className="text-ink-500"> từ {formatDateKey(entry.effectiveFrom)}</span> : null}
                                    </span>
                                ))}
                            </div>
                        ))}
                    </dd>
                </div>
            ))}
        </dl>
    );
}
